import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../../common/constants";
import api from "../../../api";
import { sendResetPasswordEmail } from "../../../config";
import { IInitialSliceState } from "../../../common/types/commonTypes";

const SEND_RESET_PASSWORD_EMAIL = "sendResetPasswordEmail";

const initialState: IInitialSliceState = {
  msg: null,
  status: Status.IDLE,
  error: null,
};

interface IResetPasswordEmailResponse {
  message: string;
}

export const sendEmail = createAsyncThunk(
  SEND_RESET_PASSWORD_EMAIL,
  async ({ email }: { email: string },{rejectWithValue}) => {
    try {
      const resetPasswordEmailResponse = await api.post<IResetPasswordEmailResponse>(
        `${sendResetPasswordEmail}`,
        {
          email,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );
      return resetPasswordEmailResponse.data;
    } catch (error) {
      console.error("Error sending reset password email: ", error);
      return rejectWithValue(error.response.data.message);
    }
  }
);

const resetPasswordEmailSlice = createSlice({
  name: SEND_RESET_PASSWORD_EMAIL,
  initialState: initialState,
  reducers: {
    resetStatus: (state) => {
      state.status = Status.IDLE;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendEmail.pending, (state) => {
        state.status = Status.PENDING;
      })
      .addCase(sendEmail.fulfilled, (state, action) => {
        state.status = Status.SUCCESS;
        state.msg = action.payload?.message ?? null;
      })
      .addCase(sendEmail.rejected, (state, action) => {
        state.status = Status.FAILED;
        state.error = action.payload as string;
      });
  },
});

type Selector = {
  sendResetPasswordEmailApi: ReturnType<typeof resetPasswordEmailSlice.reducer>;
};

export const selector = (store: Selector) => store["sendResetPasswordEmailApi"];
export const { resetStatus } = resetPasswordEmailSlice.actions;
export default resetPasswordEmailSlice.reducer;
